import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [focusedField, setFocusedField] = useState<string | null>(null);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <section id="contact" className="py-40 bg-black text-white relative overflow-hidden" data-id="element-6">
      {/* Geometric background accents */}
      <div className="absolute top-20 left-20 w-72 h-72 border border-white/5" data-id="element-7" />
      <div className="absolute bottom-40 right-20 w-56 h-56 border border-white/5" data-id="element-8" />

      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-9">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-20" data-id="element-10">
          <h2 className="text-6xl md:text-7xl font-black mb-6 tracking-tight" data-id="element-11">
            Parlons de votre projet
          </h2>
          <p className="text-xl text-gray-400 font-light" data-id="element-12">
            Contactez-nous pour discuter de vos objectifs de croissance
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-16" data-id="element-13">
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-14">
            <h3 className="text-3xl font-bold mb-12 tracking-tight" data-id="element-15">
              Contactez Nexyom
            </h3>

            <div className="space-y-8" data-id="element-16">
              <div className="flex items-start gap-5 group" data-id="element-17">
                <div className="flex-shrink-0 w-14 h-14 bg-blue-500 flex items-center justify-center transition-transform duration-300 group-hover:scale-110" data-id="element-18">
                  <MailIcon className="w-7 h-7 text-white" strokeWidth={1.5} data-id="element-19" />
                </div>
                <div data-id="element-20">
                  <p className="font-medium text-gray-500 mb-2 text-sm uppercase tracking-wider" data-id="element-21">
                    Email
                  </p>
                  <a href="mailto:contact@nexyom.fr" className="text-xl hover:text-blue-400 transition-colors duration-300 font-light" data-id="element-22">
                    contact@nexyom.fr
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-5 group" data-id="element-23">
                <div className="flex-shrink-0 w-14 h-14 bg-blue-500 flex items-center justify-center transition-transform duration-300 group-hover:scale-110" data-id="element-24">
                  <PhoneIcon className="w-7 h-7 text-white" strokeWidth={1.5} data-id="element-25" />
                </div>
                <div data-id="element-26">
                  <p className="font-medium text-gray-500 mb-2 text-sm uppercase tracking-wider" data-id="element-27">
                    Téléphone
                  </p>
                  <a href="tel:+33753293419" className="text-xl hover:text-blue-400 transition-colors duration-300 font-light" data-id="element-28">
                    +33 7 53 29 34 19
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-5 group" data-id="element-29">
                <div className="flex-shrink-0 w-14 h-14 bg-blue-500 flex items-center justify-center transition-transform duration-300 group-hover:scale-110" data-id="element-30">
                  <MapPinIcon className="w-7 h-7 text-white" strokeWidth={1.5} data-id="element-31" />
                </div>
                <div data-id="element-32">
                  <p className="font-medium text-gray-500 mb-2 text-sm uppercase tracking-wider" data-id="element-33">
                    Localisation
                  </p>
                  <p className="text-xl font-light" data-id="element-34">Paris, France</p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.form initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} onSubmit={handleSubmit} className="space-y-6" data-id="element-35">
            <div data-id="element-36">
              <label htmlFor="name" className="block text-sm font-medium text-gray-500 mb-3 uppercase tracking-wider" data-id="element-37">
                Nom complet
              </label>
              <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} onFocus={() => setFocusedField('name')} onBlur={() => setFocusedField(null)} required className="w-full px-5 py-4 bg-white/5 border-2 border-white/10 text-white placeholder-gray-600 focus:outline-none focus:border-blue-500 transition-all duration-300 font-light" placeholder="Jean Dupont" data-id="element-38" />
            </div>

            <div data-id="element-39">
              <label htmlFor="email" className="block text-sm font-medium text-gray-500 mb-3 uppercase tracking-wider" data-id="element-40">
                Email
              </label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} onFocus={() => setFocusedField('email')} onBlur={() => setFocusedField(null)} required className="w-full px-5 py-4 bg-white/5 border-2 border-white/10 text-white placeholder-gray-600 focus:outline-none focus:border-blue-500 transition-all duration-300 font-light" placeholder="jean@entreprise.com" data-id="element-41" />
            </div>

            <div data-id="element-42">
              <label htmlFor="company" className="block text-sm font-medium text-gray-500 mb-3 uppercase tracking-wider" data-id="element-43">
                Entreprise
              </label>
              <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} onFocus={() => setFocusedField('company')} onBlur={() => setFocusedField(null)} className="w-full px-5 py-4 bg-white/5 border-2 border-white/10 text-white placeholder-gray-600 focus:outline-none focus:border-blue-500 transition-all duration-300 font-light" placeholder="Nom de votre entreprise" data-id="element-44" />
            </div>

            <div data-id="element-45">
              <label htmlFor="message" className="block text-sm font-medium text-gray-500 mb-3 uppercase tracking-wider" data-id="element-46">
                Message
              </label>
              <textarea id="message" name="message" value={formData.message} onChange={handleChange} onFocus={() => setFocusedField('message')} onBlur={() => setFocusedField(null)} required rows={5} className="w-full px-5 py-4 bg-white/5 border-2 border-white/10 text-white placeholder-gray-600 focus:outline-none focus:border-blue-500 transition-all duration-300 resize-none font-light" placeholder="Parlez-nous de votre projet..." data-id="element-47" />
            </div>

            <button type="submit" className="group w-full bg-blue-500 hover:bg-blue-600 text-white px-10 py-5 font-semibold transition-all duration-300 hover:shadow-2xl hover:shadow-blue-500/20 relative overflow-hidden" data-id="element-48">
              <span className="relative z-10" data-id="element-49">Envoyer le message</span>
              <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-blue-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-50" />
            </button>
          </motion.form>
        </div>
      </div>
    </section>;
}